<script lang="ts">
    import star from 'src/components/main/marketplace/components/nft-card/star.svg'
    import plus from 'src/components/main/marketplace/components/nft-card/plus.svg'
    import {isLoggedIn, userProfile} from 'src/services/auth'
    import {Link} from 'svelte-routing'
    import {buyNft, confirmAction, isConfirmedAction} from 'src/components/main/#services/marketplace'
    import {showAlert} from 'src/components/#common/alert/store'
    import {cancelSell} from 'src/components/cabinet/#services/inventory'
    import Modal from 'src/components/cabinet/#common/modal/Modal.svelte'
    import {createEventDispatcher} from 'svelte'
    import {delay} from 'src/global/delay'

    export let item

    const dispatch = createEventDispatcher()

    let code
    let selectedNft = {}
    let buyNftModal = false
    let loading = false

    async function buyNftHandler() {
        try {
            loading = true

            await buyNft.request({ data: { productId: selectedNft?.productId } })

            showAlert.set({
                status: 'success',
                text: 'The NFT will be added to your inventory after a few seconds.'
            })
        } catch (err) {
            if (err.message) {
                showAlert.set({
                    status: 'error',
                    text: err.message
                })
            } else {
                showAlert.set({
                    status: 'error',
                    text: 'An Error Occurred, Please Try Again Later'
                })
            }
        } finally {
            loading = false
            buyNftModal = false
            setTimeout(() => {
                dispatch('changed')
            }, 500)
        }
    }

    async function cancelSellNftHandler() {
        try {
            loading = true

            await cancelSell.request({ data: { productId: selectedNft?.productId } })

            showAlert.set({
                status: 'success',
                text: 'NFT sale successfully canceled'
            })
        } catch (err) {
            if (err.message) {
                showAlert.set({
                    status: 'error',
                    text: err.message
                })
            } else {
                showAlert.set({
                    status: 'error',
                    text: 'An Error Occurred, Please Try Again Later'
                })
            }
        } finally {
            loading = false
            setTimeout(() => {
                dispatch('changed')
            }, 500)
        }
    }

    async function confirmActionHandler() {
        try {
            loading = true
            await confirmAction.request({data: {code}})
        } catch (err) {
            console.error(err)
        } finally {
            await delay(300)
            loading = false
            isConfirmedAction.reset()
            isConfirmedAction.send()
        }
    }
</script>

<Link to="nft/{item?.productId}" class="nft-card card-{item?.additionalParams?.rarity} egg-card-{item?.type === 'lootbox' && item?.productId ? item.productId.slice(-1) : ''}"
    style="background: #{item?.additionalParams?.backgroundColor};
           background-image: radial-gradient(40% 40% at 52% 43%, rgba(255, 255, 255, .6) 0%, transparent 100%);
    ">
    {#if item?.additionalParams?.elements && item?.additionalParams.elements.length}
        <div class="elements">
            {#each item.additionalParams.elements as elem}
                {#if elem.element}
                    <img src="/images/elements/{elem.element}-{elem.subElement}.svg" width="40" height="40" alt="{elem.element}">
                {/if}
            {/each}
        </div>
    {/if}
    {#if item?.additionalParams?.level}
        <div class="level">
            <span>LVL.{item.additionalParams.level}</span>
        </div>
    {/if}
    <div class="rarity rarity-id-{item?.additionalParams?.rarity}">
        <div class="image">
            {#if item?.image && item?.type === 'unit'}
                <img src="{item.image.replace('orig', 'thumb')}" width="300" height="300" alt="nft">
            {:else if item?.productId}
                <img src="/images/eggs/egg-{item.productId.slice(-1)}.png" width="300" height="300" alt="nft egg">
            {/if}
        </div>
        <div class="stars">
            {#if item?.additionalParams?.rarity}
                {#each {length: item.additionalParams.rarity + 2} as _, i}
                    {#if i < 5}<img src="{star}" alt="star">{/if}
                {/each}
                {#if item.additionalParams.rarity === 4}
                    <img src="{plus}" class="plus" alt="plus">
                {/if}
            {/if}
        </div>
    </div>
    <div class="wrapper">
        <div class="name" class:no-stars={!item?.additionalParams?.rarity}>
            {#if item?.additionalParams?.name}{item.additionalParams.name}{:else if item?.productId}Egg{/if}
            {#if item?.productId}
                <div class="id">#{item.productId.replace(/\D/g, "")}</div>
            {/if}
        </div>
        {#if $isLoggedIn && item?.userId === $userProfile.userId}
            <button class="button" disabled={loading} on:click={(e) => {
                e.preventDefault()
                selectedNft.productId = item?.productId
                selectedNft.type = item?.type
                cancelSellNftHandler()
            }}>Cancel sale</button>
        {:else if $isLoggedIn && item?.userId !== $userProfile.userId}
            <div class="button notranslate" on:click={(e) => {
                e.preventDefault()
                isConfirmedAction.reset()
                isConfirmedAction.send()
                buyNftModal = true
                selectedNft.image = item?.image ? item.image.replace('orig', 'thumb') : '/images/eggs/egg-'+item.productId.slice(-1)+'.png'
                selectedNft.type = item?.type
                selectedNft.price = item?.price
                selectedNft.currency = item?.currency
                selectedNft.productId = item?.productId
            }}>
                {#if item?.price && item?.currency}
                    {item?.price} {item?.currency}
                {:else if item?.additionalParams?.price && item?.additionalParams?.currency}
                    {item.additionalParams.price} {item.additionalParams.currency}
                {:else}
                    Not for sale
                {/if}
            </div>
        {:else}
            <div class="button">
                {#if item?.price && item?.currency}
                    {item?.price} {item?.currency}
                {:else if item?.additionalParams?.price && item?.additionalParams?.currency}
                    {item.additionalParams.price} {item.additionalParams.currency}
                {:else}
                    Not for sale
                {/if}
            </div>
        {/if}
    </div>
</Link>

<Modal bind:visible={buyNftModal}>
    <svelte:fragment slot="content">
        <div class="modal-custom__title">Buy NFT</div>
        {#if !$isConfirmedAction.hasValue && $isConfirmedAction.loading}
            <div class="modal-custom__text text-center">Loading...</div>
        {:else if !$isConfirmedAction.hasValue && $isConfirmedAction.error}
            <div class="modal-custom__text text-center">Something went wrong. Try refreshing the page.</div>
        {:else if $isConfirmedAction.hasValue}
            {#if !$isConfirmedAction.value}
                <div class="modal-custom__text">
                    <p>We have sent an email confirming the marketplace actions</p>
                    <div class="text-center">
                        <div class="form-group mb-3">
                            <input type="text" class="form-control confirm-action-field" bind:value={code} placeholder="Enter code">
                            <div class="invalid-feedback mt-2" class:d-block={$confirmAction.error}>{$confirmAction.error}</div>
                        </div>
                        <button class="btn btn-primary" on:click={confirmActionHandler} class:loading={loading} class:disabled={!code}>
                            <span>Confirm</span>
                        </button>
                    </div>
                </div>
            {:else}
                <div class="modal-custom__text">
                    <div class="nft-card card-{item?.additionalParams?.rarity} egg-card-{item?.type === 'lootbox' && item?.productId ? item.productId.slice(-1) : ''}"
                        style="background: #{item?.additionalParams?.backgroundColor};
                               background-image: radial-gradient(40% 40% at 52% 43%, rgba(255, 255, 255, .6) 0%, transparent 100%);
                        ">
                        {#if item?.additionalParams?.elements && item?.additionalParams.elements.length}
                            <div class="elements">
                                {#each item.additionalParams.elements as elem}
                                    {#if elem.element}
                                        <img src="/images/elements/{elem.element}-{elem.subElement}.svg" width="40" height="40" alt="{elem.element}">
                                    {/if}
                                {/each}
                            </div>
                        {/if}
                        {#if item?.additionalParams?.level}
                            <div class="level">
                                <span>LVL.{item.additionalParams.level}</span>
                            </div>
                        {/if}
                        <div class="rarity rarity-id-{item?.additionalParams?.rarity}">
                            <div class="image">
                                {#if item?.image && item?.type === 'unit'}
                                    <img src="{item.image.replace('orig', 'thumb')}" width="300" height="300" alt="nft">
                                {:else if item?.productId}
                                    <img src="/images/eggs/egg-{item.productId.slice(-1)}.png" width="300" height="300" alt="nft egg">
                                {/if}
                            </div>
                            <div class="stars">
                                {#if item?.additionalParams?.rarity}
                                    {#each {length: item.additionalParams.rarity + 2} as _, i}
                                        {#if i < 5}<img src="{star}" alt="star">{/if}
                                    {/each}
                                    {#if item.additionalParams.rarity === 4}
                                        <img src="{plus}" class="plus" alt="plus">
                                    {/if}
                                {/if}
                            </div>
                        </div>
                        <div class="wrapper">
                            <div class="name" class:no-stars={!item?.additionalParams?.rarity}>
                                {#if item?.additionalParams?.name}{item.additionalParams.name}{:else if item?.productId}Egg{/if}
                                {#if item?.productId}
                                    <div class="id">#{item.productId.replace(/\D/g, "")}</div>
                                {/if}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-custom__footer">
                    <button class="btn btn-cancel" on:click={() => { buyNftModal = false }} disabled={loading}>Cancel</button>
                    <button class="btn btn-primary" class:loading={loading} on:click={() => buyNftHandler()} disabled={loading}><span>Confirm</span></button>
                </div>
            {/if}
        {/if}
    </svelte:fragment>
</Modal>

<style>
    :global(.nft-card) {
        background: radial-gradient(53.15% 53.15% at 50% 46.85%, #566478 0%, #323B45 100%);
        border-radius: 8px;
        border: 2px solid white;
        display: block;
        text-decoration: none;
        margin-bottom: 24px;
        position: relative;
        transition: .25s;
        overflow: hidden;
    }

    :global(.nft-card:hover) {
        transform: translateY(-4px);
        box-shadow: 0 8px 10px rgba(160, 174, 192, 0.2);
    }

    .wrapper {
        padding: 15px;
        box-shadow: 0 -3px 0 0 rgba(0, 0, 0, 0.25) inset;
        border-radius: 0 0 8px 8px;
        background: rgba(119, 132, 151, .5);
    }

    .elements {
        position: absolute;
        left: 15px;
        top: 15px;
        z-index: 2;
    }

    .elements img:not(:first-child) {
        margin-left: -10px;
    }

    .level {
        position: absolute;
        right: -2px;
        top: -2px;
        font-size: 15px;
        font-family: 'Anton', sans-serif;
        color: white;
        padding: 5px 18px;
        line-height: normal;
        border: 2px solid white;
        border-radius: 0 8px 0 8px;
        box-shadow: 0 0 10px 1px rgba(0, 0, 0, 0.5) inset;
        text-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
    }

    .stars {
        text-align: center;
        margin-top: -10px;
        height: 32px;
        margin-bottom: 15px;
    }

    .stars img:not(:first-child) {
        margin-left: 5px;
    }

    .image {
        margin-top: 15px;
        text-align: center;
    }

    .image img {
        max-width: 100%;
        max-height: 300px;
        height: auto;
    }

    .name {
        font-size: 25px;
        color: white;
        font-family: 'Anton', sans-serif;
        line-height: normal;
        text-shadow: 2px 0 0 #000, -2px 0 0 #000, 0 2px 0 #000, 0 -2px 0 #000, 1px 1px #000, -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000;
        position: relative;
        margin-bottom: 5px;
    }

    .id {
        font-size: 18px;
        position: absolute;
        right: 0;
        bottom: 2px;
    }

    .button {
        background: #FF5D1C;
        color: white;
        line-height: normal;
        padding: 5px;
        width: 100%;
        border-radius: 8px;
        font-family: 'Anton', sans-serif;
        text-shadow: 2px 0 0 #000, -2px 0 0 #000, 0 2px 0 #000, 0 -2px 0 #000, 1px 1px #000, -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000;
        text-transform: uppercase;
        font-size: 30px;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
        text-decoration: none;
        letter-spacing: 1px;
        transition: .25s;
        border: 1px solid #01070A;
        box-shadow: 0 -3px 0 0 rgba(0, 0, 0, 0.25) inset;
    }

    .button:hover {
        box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.25) inset;
    }

    .modal-custom__text .nft-card {
        max-width: 340px;
        margin: 0 auto;
        zoom: .7;
    }

    .modal-custom__text .nft-card:hover {
        transform: none;
        box-shadow: none;
    }

    .modal-custom__footer {
        display: flex;
    }

    .modal-custom__footer .btn:first-child {
        margin-left: 0;
    }

    .modal-custom__footer .btn {
        width: 50%;
    }

    .form-control.confirm-action-field {
        border: 1px solid #CAD5E0;
        font-size: 16px;
        color: white;
        padding: 10px 15px;
        margin: 0 auto;
        text-align: center;
        max-width: 200px;
        border-radius: 8px;
    }

    .form-control.confirm-action-field:focus {
        box-shadow: none;
    }

    .form-control.confirm-action-field:focus {
        border-color: #FF5D1C;
    }

    @media(max-width: 767px) {
        :global(.nft-card:hover) {
            transform: none;
            box-shadow: none;
        }

        .modal-custom__footer .btn {
            padding: 12px 6px;
        }

        .wrapper {
            padding: 6px;
        }

        .button {
            font-size: 16px;
        }

        .elements {
            left: 5px;
            top: 5px;
        }

        .elements img {
            width: 28px;
            height: 28px;
        }

        .elements img:not(:first-child) {
            margin-left: -8px;
        }

        .level {
            font-size: 12px;
            padding: 5px 12px;
        }

        .stars img {
            width: 17px;
        }

        .stars img:not(:first-child) {
            margin-left: 3px;
        }

        .name {
            font-size: 18px;
        }

        .id {
            font-size: 14px;
        }

        .stars {
            height: 20px;
            margin-bottom: 8px;
        }
    }
</style>
